export default __webpack_public_path__ + "static/media/11.d8b56bb3.webp";